import { expenseServiceApi } from "../../app/expenseServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType, PostQueryArgsType } from "../../types";
import {
  GetPettyCashDetailsResponseType,
  GetPettyCashIDResponseType,
  GetPettyCashParams,
  GetPettyCashResponseType,
} from "../../types/pettyCash";

export const pettyCashApi = expenseServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getPettyCash: builder.query<
      GetPettyCashResponseType,
      GetQueryArgsType<GetPettyCashParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getPettyCash,
        ...queryArgs,
      }),
      providesTags: ["GetPettyCash"],
    }),
    getPettyCashId: builder.query<
      GetPettyCashIDResponseType,
      GetQueryArgsType<GetPettyCashParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getPettyCashId,
        ...queryArgs,
      }),
      providesTags: ["GetPettyCashID"],
    }),
    getPettyCashDetails: builder.query<GetPettyCashDetailsResponseType, number>(
      {
        query: (id) => ({
          url: `${API_URL.getPettyCashDetails}/${id}`,
        }),
        providesTags: ["GetPettyCashDetails"],
      }
    ),
    pettyCashSend: builder.mutation<unknown, PostQueryArgsType>({
      query: ({ body }) => ({
        url: `${API_URL.pettyCashSend}`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result) => {
        if (result)
          return ["GetPettyCash", "GetPettyCashID", "GetPettyCashDetails"];

        return [];
      },
    }),
  }),
});

export const {
  useGetPettyCashQuery,
  useGetPettyCashIdQuery,
  useGetPettyCashDetailsQuery,
  usePettyCashSendMutation,
} = pettyCashApi;
